import styles from "./index.css";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";
import { getFilterButtonFocused } from "../../state/modules/layout/selectors";
import { useRef, useEffect } from "react";

const FilterAndSort = ({
  showFilterOverlay,
  showSortOverlay,
  formatTranslation,
  hasFacets
}) => {
  const filterButtonRef = useRef(null);
  useEffect(() => {
    if (getFilterButtonFocused === true) {
      filterButtonRef.current.focus();
    }
  }, [getFilterButtonFocused]);

  return (
    <div className={styles.container}>
      <div className={styles.iconWrap}>
        <button
          className={styles.button}
          onClick={showSortOverlay}
          data-testid="sort-button"
          disabled={!hasFacets}
        >
          <span>{formatTranslation("plp_web_sort_sort")}</span>
          <span className={styles.sort} />
        </button>

        <button
          className={styles.button}
          onClick={showFilterOverlay}
          ref={filterButtonRef}
          data-testid="filter-button-desktop"
          disabled={!hasFacets}
        >
          <span>{formatTranslation("plp_web_refinements_list_filter")}</span>
          <span className={styles.filter} />
        </button>
      </div>
    </div>
  );
};

FilterAndSort.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  showFilterOverlay: PropTypes.func.isRequired,
  showSortOverlay: PropTypes.func.isRequired,
  hasFacets: PropTypes.bool.isRequired
};

export default withTranslation(FilterAndSort);
